import { ComponentPropsWithoutRef, ElementType } from 'react';
import s from './Typography.module.scss';

export type Variant =
    | 'error'
    | 'h1'
    | 'h1_bold'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h4_bold'
    | 'h5'
    | 'h5_bold'
    | 'h5_gray'
    | 'h6'
    | 'h6_bold'
    | 'h6_green'
    | 'link'
    | 'text_11'
    | 'text_11_gray'
    | 'text_12'
    | 'text_12_gray'
    | 'text_14'
    | 'text_14_gray'
    | 'text_16'
    | 'text_16_bold'
    | 'text_16_gray'
    | 'text_16_green'
    | 'text_18'
    | 'text_18_bold'
    | 'text_18_gray';

export type TypographyProps<T extends ElementType> = {
    as?: T;
    className?: string;
    variant?: Variant;
    onClick?: () => void;
} & ComponentPropsWithoutRef<T>;

export const Typography = <T extends ElementType>(props: TypographyProps<T>) => {
    const { as: Component = 'p', className, variant = 'text_18px', ...rest } = props;

    return <Component className={`${s[variant]} ${className}`} {...rest} />;
};
